import React, { useEffect, useState } from 'react'
import { Marker, Popup, useMap, useMapEvents } from 'react-leaflet';

import { HiMapPin } from "react-icons/hi2";
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import 'leaflet-draw/dist/leaflet.draw.css';
import  loaction from   "../../../assets/images/logo/location.png"
import classes from "./currentLoction.module.css"
const CurrentLocationButton = () => {
    const [position, setPosition] = useState(null)    
    const map = useMap();
    const locationIcon = new L.Icon({
        iconUrl: loaction,
        iconSize: [50, 50], // size of the icon
        iconAnchor: [25, 50], // point of the icon which will correspond to marker's location
        popupAnchor: [0, -50] // point from which the popup should open relative to the iconAnchor
      })
  
    const handleClick = () => {
        map.locate();
    };
      useMapEvents({
   
      locationfound(e) {
        setPosition(e.latlng)
        map.flyTo(e.latlng, map.getZoom())
      },
    })
  
    return    <>
    <button onClick={handleClick} className={classes.currentLoction}>
        <HiMapPin size={20} />
    </button>
    {position && (
        <Marker position={position} icon={locationIcon}>
            <Popup>You are here</Popup>
        </Marker>
    )}
</>
    
  }

   


export default CurrentLocationButton;